import { citas } from './siteActions/citas'
import { civiiChat } from '@/civii-chat/actions/civiiChatActions.js'


function obtenerPlaca() {
    let storage = localStorage.getItem('civiiMessages');
    let cantidadMensajes = JSON.parse(storage).length;
    let mensaje = JSON.parse(storage)[cantidadMensajes - 4];
    let messages = mensaje['messages'];
    let texto = messages[0];
    return texto['text'];
}

function checkPagos(lista, checkFunction) {
    for (var row in lista) {
        if (!lista[row].checkPago) {
            lista[row].checkPago = true
            checkFunction(row)
        }
    }
}

export let actions = {
    civiiChat,
    verFotoMulta(args) {
        $UTIL.loader.show()
        let homeMultasScope = angular.element(document.getElementById('homeMultasController')).scope()
        if (homeMultasScope == null) {
            window.open('#/inicio-home', '_self')
            homeMultasScope = angular.element(document.getElementById('homeMultasController')).scope()
            setTimeout(function() {
                checkFotoMulta()
            }, 4000)
        } else {
            checkFotoMulta()
        }

        function checkFotoMulta() {
            if (args.tipo === 'COMPARENDO') homeMultasScope.homeMultasController.checkDetalleFotoMulta(args.index)
            else if (args.tipo === 'MULTA') homeMultasScope.homeMultasController.checkDetalleFotoMultaMoroso(args.index)
            $UTIL.loader.hide()
        }
    },
    licenciaConduccion() {
        window.open('#/inicio/consultar-estado-licencia', '_self')
        document.getElementById('idLicenciasEstadoInput').value = sessionStorage.getItem('nroIdentificacion')
    },
    iniciarPagosMultas() {
        $UTIL.loader.show()
        let homeMultasScope = angular.element(document.getElementById('homeMultasController')).scope()
        if (homeMultasScope == null) {
            window.open('#/inicio-home', '_self')
            homeMultasScope = angular.element(document.getElementById('homeMultasController')).scope()
            setTimeout(function() {
                seleccionAllPagos()
            }, 4000)
        } else {
            seleccionAllPagos()
        }

        function seleccionAllPagos() {
            let listComparendos = homeMultasScope.homeMultasController.infoMultas.informacionComparendo
            let listMultas = homeMultasScope.homeMultasController.infoMultas.informacionMulta
            checkPagos(listComparendos, homeMultasScope.homeMultasController.checkPagoComparendo)
            checkPagos(listMultas, homeMultasScope.homeMultasController.checkPagoMoroso)
            homeMultasScope.$apply()
            homeMultasScope.homeMultasController.validarPago()
            $UTIL.loader.hide()
        }
    },
    iniciarAp() {
        $UTIL.loader.show()
        let homeMultasScope = angular.element(document.getElementById('homeMultasController')).scope()
        if (homeMultasScope == null) {
            window.open('#/inicio-home', '_self')
            homeMultasScope = angular.element(document.getElementById('homeMultasController')).scope()
            setTimeout(function() {
                seleccionAllAp()
            }, 4000)
        } else {
            seleccionAllAp()
        }

        function seleccionAllAp() {
            let listMultas = homeMultasScope.homeMultasController.infoMultas.informacionMulta
            checkPagos(listMultas, homeMultasScope.homeMultasController.checkPagoMoroso)
            homeMultasScope.$apply()
            homeMultasScope.homeMultasController.validarAp()
            $UTIL.loader.hide()
        }
    },
    verVehiculoInmovilizado(args) {
        window.open('#/inicio-home', '_self')
        angular.element(document.getElementById('homeVehiculoController'))
            .scope().homeVehiculoController.validarEntregaVeh(args.placa)
    },
    consultarMultasIdentificacion(arg) {
        /*let url = 'https://www.medellin.gov.co/portal-movilidad/#/public?valor=' + String(arg.inputText).toUpperCase() + '&tipo=0';
        window.open(url, "_self");*/

        angular.element(document.getElementById('busqueda')).scope().ctrl.input = arg.inputText.toUpperCase();
        document.getElementById('btnBuscar').click();
    },
    consultarMultas(arg) {
        let placa = obtenerPlaca();

        angular.element(document.getElementById('busqueda')).scope().ctrl.input = placa.toUpperCase();
        document.getElementById('btnBuscar').click();
    },
    consultarEstadoVehiculo(arg) {
        let placa = obtenerPlaca();

        angular.element(document.getElementsByClassName("field-input__estado")[0]).scope().ctrl.inputEstadoVehiculo = placa.toUpperCase();
        document.getElementsByClassName("button-estado")[0].click();
    },
    consultarExentos(arg) {
        let placa = obtenerPlaca();

        angular.element(document.getElementById("field-input__exento")).scope().ctrl.inputPlacaExento = placa.toUpperCase();
        document.getElementsByClassName("button-exento")[0].click();
    },
    citas
}


// WEBPACK FOOTER //
// ./src/servicios_digitales/siteActions.js